/** Where a point in the text is, as characters from its start, so it can be found again after the text is rebuilt. */
export function offsetOf(root: HTMLElement, node: Node, offset: number) {
  const range = document.createRange();

  range.setStart(root, 0);
  range.setEnd(node, offset);
  return range.toString().length;
}

export function pointAt(root: HTMLElement, target: number): [Node, number] {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let seen = 0;

  for (let node = walker.nextNode() as Text | null; node; node = walker.nextNode() as Text | null) {
    if (target <= seen + node.length) {
      return [node, target - seen];
    }

    seen += node.length;
  }

  return [root, root.childNodes.length];
}

/** The elements from the text's own blocks down to the one holding the point, as `ul > li > strong`. */
export function elementPath(root: HTMLElement, node: Node) {
  const names: string[] = [];

  for (let element = node.nodeType === 1 ? (node as Element) : node.parentElement; element && element !== root; element = element.parentElement) {
    names.unshift(element.nodeName.toLowerCase());
  }

  return names.join(" > ");
}
